import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import React, { FC } from 'react'

import './LearningPathItem.scss'

interface ILearningPathItemProps {
  id?: string
  completed?: boolean
  current?: boolean
  item: {title: string, content: string}
}

const LearningPathItem: FC<ILearningPathItemProps> = ({
  item,
  completed,
  current,
  id,
}) => {
  return (
    <div
      className={`learning-path-item--layout ${completed ? 'completed' : ''} ${current ? 'current' : ''}`}
      id={id}
    >
      <div className="container-text">
        <TextComponent
          type='text'
          style={{ color: 'var(--primary)' }}
        >
          {item?.content}
        </TextComponent>
      </div>
    </div>
  )
}

export default LearningPathItem
